var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('br'),_c('div',{staticClass:"card text-center mx-auto",staticStyle:{"width":"24rem"}},[_c('div',{staticClass:"card-body py-5"},[_c('h5',{staticClass:"card-title"},[_vm._v("You don't have any saved recipes!")]),_c('p',{staticClass:"card-text"},[_vm._v("Click Actions & Info > Add Cocktail above to add your first recipe.")])])])])
}]

export { render, staticRenderFns }